import { Reveal, Label } from "./Reveal";

// The signature brand differentiator — placed right after the dark
// EmotionalTurn (2:13 a.m.) so it answers the exact moment that section
// built: when real life happens mid-plan, Andrea is already in your corner.
const MOMENTS = [
  {
    n: "01",
    text: "The nap that went nothing like the plan — and you want to know what tonight gets now.",
  },
  {
    n: "02",
    text: "Bedtime fell apart halfway through — do you start over, or keep going?",
  },
  {
    n: "03",
    text: "Your child reacted differently than you expected — normal, or a sign to change something?",
  },
  {
    n: "04",
    text: "The quiet \u201cwhat do I do now?\u201d at 9:40 p.m. — answered by someone who already knows your child.",
  },
];

export const InYourCorner = () => (
  <section id="in-your-corner" data-testid="in-your-corner-section" className="bg-ivory">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 py-24 lg:py-36">
      <div className="max-w-4xl">
        <Reveal>
          <Label>The part that&rsquo;s different</Label>
        </Reveal>
        <Reveal as="h2" delay={0.08} data-testid="in-your-corner-headline" className="mt-8 font-serif font-light text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight">
          Having instructions is different
          <span className="block">from having someone</span>
          <span className="block italic text-clay">in your corner.</span>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-10 max-w-2xl text-base sm:text-lg font-normal leading-relaxed text-smoke">
            Any book can hand you a schedule. What it can&rsquo;t do is answer
            you on the Thursday when the nap goes sideways, bedtime falls
            apart, and you&rsquo;re standing in the hallway wondering whether
            to hold the line or adjust.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 lg:mt-20 grid grid-cols-1 md:grid-cols-2 gap-x-14 border-t border-ink/10">
        {MOMENTS.map((m, i) => (
          <Reveal key={m.n} delay={0.08 + i * 0.06}>
            <div data-testid={`corner-moment-${i}`} className="py-7 border-b border-ink/10 flex gap-6 items-baseline">
              <span aria-hidden="true" className="font-serif italic font-light text-clay/60 text-sm shrink-0">
                {m.n}
              </span>
              <p className="text-base sm:text-lg font-normal leading-relaxed text-smoke">
                {m.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-16 lg:mt-20 max-w-3xl">
        <p className="font-serif font-light text-ink text-2xl sm:text-3xl lg:text-4xl leading-[1.18] tracking-tight">
          I already know your child, your routine, and what we&rsquo;ve
          tried — so when real life happens, you&rsquo;re asking me.
          <span className="block mt-3 italic text-clay">Not the internet.</span>
        </p>
        <p className="mt-8 font-serif italic font-light text-clay text-xl sm:text-2xl">
          — that&rsquo;s the corner I sit in.
        </p>
      </Reveal>
    </div>
  </section>
);
